import { t, Trans } from '@lingui/macro'
import { Button, useAccordionContext } from '@tecsinapse/cortex-react'
import React, { useEffect, useRef } from 'react'
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io'
import { TipoAcesso } from '@/core/types/graphql'
import { isArrayofStrings } from '@/core/utils/is-array-of-strings'
import { OptionSelect } from '@/core/utils/types'
import { Select } from '@/core/components/select'

export const TriggerAccordion = (props: any) => {
  const {
    produto,
    setProdutos,
    setOpen,
    selectedTiposAcessos,
    onChangeTipoAcesso,
    tourId,
    setOpenTour
  } = props
  const { toggle, open } = useAccordionContext()
  const openRef = useRef(false)

  useEffect(() => {
    if (
      !openRef.current &&
      selectedTiposAcessos?.length > 0 &&
      !open &&
      tourId
    ) {
      openRef.current = true
      toggle?.()
      setOpenTour?.()
    }
  }, [open, openRef, selectedTiposAcessos?.length, setOpenTour, toggle, tourId])

  const tiposAcessosOptions = Object.keys(produto?.tiposAcesso as TipoAcesso[])
    .map(key => {
      const typedKey = key as keyof (typeof produto)['tiposAcesso']
      return {
        label: produto?.tiposAcesso?.[typedKey]?.['nome'] ?? '',
        value: produto?.tiposAcesso?.[typedKey]?.['id'] ?? ''
      }
    })
    .sort((tp1, tp2) => {
      if (tp1.label < tp2.label) {
        return -1
      }
      if (tp1.label > tp2.label) {
        return 1
      }
      return 0
    })

  const formatValue = isArrayofStrings(selectedTiposAcessos)
    ? tiposAcessosOptions.filter(op =>
        selectedTiposAcessos.find(item => {
          return (item as unknown as string) === op?.value
        })
      )
    : tiposAcessosOptions.filter(op =>
        (selectedTiposAcessos as OptionSelect[]).find(
          item => item?.value === op?.value
        )
      )

  return (
    <div className='px-deca flex flex-row items-center justify-between space-x-deca'>
      <p className={'font-bold w-[20%]'}>{produto.nome}</p>
      <Select
        id={`${tourId}-select`}
        className={'w-full'}
        name={`select_tiposacesso_${produto?.id}`}
        label={t`Acessos`}
        value={formatValue}
        options={tiposAcessosOptions}
        onSelect={value => {
          onChangeTipoAcesso(value)
        }}
        keyExtractor={opt => opt?.value}
        labelExtractor={opt => opt?.label}
        isMultiSelect
        disabled={tiposAcessosOptions.length < 1}
      />
      <Button
        type={'button'}
        variants={{
          variant: 'outline',
          className: 'py-0 w-[25%]'
        }}
        onClick={() => {
          setProdutos([produto])
          setOpen(true)
        }}
      >
        <Trans>Clonar permissões</Trans>
      </Button>
      <Button
        type={'button'}
        variants={{ variant: 'text', size: 'small' }}
        onClick={toggle}
      >
        {open ? <IoIosArrowUp size={20} /> : <IoIosArrowDown size={20} />}
      </Button>
    </div>
  )
}
